<template>
    <div>
        <div class="text-right mb-3">
            <gofix-button :loading="loading" @click="savePreCondition" :disabled="Item.job_status != 'Planned' && Item.job_status != 'Due'" class="mr-2 dark" label="Save Pre-Condition Checklist"></gofix-button>
        </div>
        <gofix-card :class="['position-relative mb-13 pt-16 px-24 pb-19', {'run-loading': loadingCheckListEntry }]" classHeader="mb-0 pd-0" classContent="pd-0 mb-0">
            <b-row no-gutters>
                <template v-for="(item, index) in tableItems">
                    <b-col md="12" class="mb-13" :key="index" v-if="item.children.length == 0">
                        <CheckListPreEntries 
                            :section="item.name" 
                            @updateCheckListPreEntries="updateCheckListPreEntries" 
                            @reloadChecklist="reloadChecklist" 
                            @inputType="isTyping = true" 
                            :item="item"></CheckListPreEntries>
                    </b-col>
                    <template v-else>
                        <template v-for="(itemChild) in item.children">
                            <b-col md="12" class="mb-13" :key="itemChild.id">
                                <CheckListPreEntries 
                                :section="item.name + ' >> ' + itemChild.name" @updateCheckListPreEntries="updateCheckListPreEntries" 
                                @reloadChecklist="reloadChecklist" 
                                @inputType="isTyping = true" 
                                :item="itemChild"></CheckListPreEntries>
                            </b-col>
                        </template>
                    </template>
                </template>
            </b-row>
        </gofix-card>
    </div>
</template>
<script>
    import {
        mapGetters
    } from "vuex";

    const CheckListPreEntries = () => import("./CheckListPreEntries");

    export default {
        name: 'pre-condition-checklist',
        components: {
            CheckListPreEntries
        },
        props: {
            itemProp: {
                type: Object,
                default: () => {}
            },
        },
        data() {
            return {
                loading: false,
                loadingCheckListEntry: false,
                tableItems: [],
                checkListEntryUpdate: [],
            }
        },
        computed: {
            ...mapGetters({
                UserLogin: "AuthController/user",
                Item: "JobController/Item",
                Loadings: "JobController/Loadings",
            }),
        },
        watch: {
            isTyping: function(val) {
                if(val === false && this.isSave === true) {
                    this.savePreCondition();
                }
            }
        },
        mounted() {

        },
        created() {
            if (
                !this.$route.params.hasOwnProperty('id') ||
                isNaN(this.$route.params.id)
            ) {
                return this.$router.push({
                    name: 'job-list'
                });
            }
            
            this.getCheckListGroupData();
        },
        methods: {
            reloadChecklist() {
                this.getCheckListGroupData();
            },
            async getCheckListGroupData() {
                this.loadingCheckListEntry = true;

                if ( !this.itemProp.pre_condition_checklists ) {
                    this.loadingCheckListEntry = false;
                    return false;
                }

                await this.$store
                .dispatch('CheckListController/getPreCheckListGroupData', this.itemProp.pre_condition_checklists.group_root_id)
                .then((result) => {
                    this.tableItems = result.data.data.items;
                    this.loadingCheckListEntry = false;
                })
                .catch((err) => {
                    this.loadingCheckListEntry = false;
                });
            },
            async updateCheckListPreEntries(val){
                let params = val;
                let request = {
                    id: params.val.id,
                    value: params.val.input.value,
                    status: params.val.status,
                }

                if(params.val.hasOwnProperty('output')) request.output = params.val.output;
                if(params.val.hasOwnProperty('is_output_highlighted')) request.is_output_highlighted = params.val.is_output_highlighted;

                if(!params.from_status){
                    if(params.val.input.value){ request.status = params.val.status = 'Filled'; }
                    else{ request.status = params.val.status = 'Unfilled';}
                }

                let checkListEntryData = [request];
                if(this.checkListEntryUpdate.length > 0){
                    checkListEntryData = Object.assign([], this.checkListEntryUpdate);
                }

                let flag = false;
                if(checkListEntryData.length > 0){
                    for (let i = 0; i < checkListEntryData.length; i++) {
                        if (request && request.id == checkListEntryData[i].id) {
                            this.checkListEntryUpdate[i] = request;
                            flag = true;
                            break;
                        }
                    }
                    if(!flag){
                        this.checkListEntryUpdate.push(request);
                    }
                }
                
                this.isTyping = false;
            },
            async getItemJob(callback) {
                await this.$store.dispatch('JobController/getItem', this.$route.params.id)
                .then((response) => {})
                .catch((err) => {
                    this.$alertNotification('Can not load job list', 'danger');
                });
            },
            async savePreCondition() {
                this.loading = true;
                
                let request = {
                    array_data: JSON.stringify(this.checkListEntryUpdate),
                    job_id: this.Item.id
                };

                this.$store
                .dispatch("CheckListController/updatePreCheckListJob", request)
                .then(async (data) => {
                    await this.getItemJob();
                    this.loading = await false;
                    this.checkListEntryUpdate = [];
                    this.$alertNotification('Update successfully Pre-Condition Checklist', 'success');
                })
                .catch((err) => {
                    this.$alertNotification('Can not update Pre-Condition Checklist', 'danger');
                    this.loading = false;
                });
            }
        },
    };
</script>